import { useState } from "react";
import { motion } from "framer-motion";
import { Calendar, Clock, Users, MapPin, Sparkles } from "lucide-react";

const UpcomingEventsSection = ({ onBookClick }) => {
  const event = {
    title: "Girls Night Out",
    date: "April 3rd, 2026",
    time: "8:00 PM - 10:30 PM",
    spotsLeft: 15,
    maxSpots: 15,
    description: "Join us for an unforgettable evening of hat making, wine, and good vibes! Limited seats available - book now to secure your spot.",
  };

  const eventFlyer = "https://customer-assets.emergentagent.com/job_threaded-events/artifacts/1ke5jswd_9F575D7A-4758-420E-AE37-34FBF383CF83.PNG";
  const cashAppQR = "https://customer-assets.emergentagent.com/job_threaded-events/artifacts/m30jrqri_Screenshot%202026-03-07%20at%208.39.54%E2%80%AFPM.png";
  const zelleQR = "https://customer-assets.emergentagent.com/job_threaded-events/artifacts/oil4vmnz_Croped%20Payment%20Zelle%20QR.png";

  return (
    <section id="upcoming-events" data-testid="upcoming-events-section" className="py-20 md:py-32 px-4 md:px-8 lg:px-16 bg-gradient-to-b from-[#0A0A0A] to-[#050505]">
      <div className="max-w-5xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <Calendar className="w-8 h-8 text-gold mx-auto mb-4" />
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl mb-4">
            Upcoming <span className="text-gold">Event</span>
          </h2>
          <p className="text-zinc-400 text-lg">
            Don't miss out - limited seats available!
          </p>
        </motion.div>

        {/* Featured Event Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="relative"
        >
          {/* Glow effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-rose/20 via-gold/20 to-rose/20 blur-3xl opacity-30" />
          
          <div className="relative glass-card border border-gold/30 overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Event Flyer Image */}
              <div className="relative">
                <img 
                  src={eventFlyer}
                  alt="Girls Night Hat Making & Sip Experience - April 3rd @ 8PM"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Payment QR Codes & Booking */}
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <h3 className="font-heading text-2xl md:text-3xl text-white mb-4">
                  Reserve Your Spot
                </h3>
                <p className="text-zinc-400 mb-6">
                  Scan to pay and secure your seat for this exclusive event!
                </p>

                {/* QR Codes */}
                <div className="flex justify-center gap-6 mb-8">
                  <div className="flex flex-col items-center">
                    <img 
                      src={cashAppQR} 
                      alt="CashApp QR Code"
                      className="w-32 h-32 md:w-36 md:h-36 object-contain rounded-lg"
                    />
                    <p className="text-gold font-medium mt-2">CashApp</p>
                    <p className="text-white text-sm">$dainaLaneeBrand</p>
                  </div>
                  <div className="flex flex-col items-center">
                    <img 
                      src={zelleQR} 
                      alt="Zelle QR Code"
                      className="w-32 h-32 md:w-36 md:h-36 object-contain rounded-lg"
                    />
                    <p className="text-gold font-medium mt-2">Zelle</p>
                    <p className="text-white text-sm">dailightdg@gmail.com</p>
                  </div>
                </div>

                <button
                  onClick={() => onBookClick("patch_class")}
                  className="btn-gold w-full mb-4"
                  data-testid="book-april-event-btn"
                >
                  Book Your Spot Now
                </button>

                <p className="text-sm text-zinc-500 text-center">
                  Questions? Call <a href="tel:7085390789" className="text-rose">708-539-0789</a>
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default UpcomingEventsSection;
